"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGIcon = void 0;
const react_1 = __importDefault(require("react"));
require("./Icon.scss");
// Base class for SVG Icons
const SVGIcon = (props) => {
    var _a;
    return (react_1.default.createElement("svg", { ...props, className: "svg-icon " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), style: {
            width: props.size ? props.size : "1em",
            height: props.size ? props.size : "1em",
            ...props.style,
        }, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props.children));
};
exports.SVGIcon = SVGIcon;
